import React from 'react';
import { colors } from '../../config/constants';

type HeadingProps = {
  label: string;
  color?: string;
};

const PageHeading = (props: HeadingProps) => {
  return (
    <div
      data-testid="heading-wrapper"
      className={`flex items-center justify-between pb-1 mb-2 ${
        colors.primaryBorder
      } ${props.color ? 'text-[#27374D]' : 'text-white'} `}
    >
      <div className="text-[20px] font-semibold " data-testid="heading-label">
        {props.label}
      </div>
    </div>
  );
};

export default PageHeading;
